// src/pages/learners/LearnerExamEntry.jsx
import { useEffect } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { startLearnerRun } from "@/api/kuizy";

export default function LearnerExamEntry() {
  const [sp] = useSearchParams();
  const nav = useNavigate();
  useEffect(() => {
    (async () => {
      try {
        const course_id = sp.get("course_id");
        const test_id = sp.get("test_id");
        if (!course_id || !test_id) {
          nav("/learn", { replace: true });
          return;
        }
        const { data } = await startLearnerRun({ course_id, test_id });
        const runId = data?.run_id || data?.id || data?.test_run_id;
        if (!runId) throw new Error("no_run_id");
        nav(`/learn/exam/${runId}`, { replace: true });
      } catch {
        nav("/learn", { replace: true });
      }
    })();
  }, [sp, nav]);
  return <div className="min-h-screen grid place-items-center">กำลังเริ่มข้อสอบ…</div>;
}
